import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.overcast,
  errorColor: colors.warningRed
};
export default book;